import { Injectable, inject, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { isPlatformServer } from '@angular/common';

const SERVER_LOGS_KEY = makeStateKey<{ label: string; data: any }[]>('server-logs-transfer');

@Injectable({ providedIn: 'root' })
export class ServerLogTransferService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly transferState = inject(TransferState);
  private logs: { label: string; data: any }[] = [];

  constructor() {
    if (!isPlatformServer(this.platformId)) {
      const serverLogs = this.transferState.get(SERVER_LOGS_KEY, null);      
      if (serverLogs && serverLogs.length > 0) {
        console.groupCollapsed('🌐 Server Logs Received');
        serverLogs.forEach(log => {
          console.log(`[Server] ${log.label}:`, log.data);
        });
        console.groupEnd();
      }
    }
  }

  /**
   * Logs data. If on the server, it will be transferred and printed on the client console.
   * If on the client, it simply logs it to the console immediately.
   * 
   * @param label A descriptive label for the log
   * @param data The data you want to log
   */
  log(label: string, data: any): void {
    if (isPlatformServer(this.platformId)) {
      // In SSR terminal
      console.log(`[Server] ${label}:`, data);
      
      // Save for transfer
      this.logs.push({ label, data });
      this.transferState.set(SERVER_LOGS_KEY, this.logs);
    }
  }
}
